export const filters = [
  {filter: "all", trans: "filterAll"},
  {filter: "doctors", trans: "doctors"},
  {filter: "operators", trans: "operators"},
]